import { Subcollection } from "@/modules/snapshots/snapshotCollection.types";

import { SubcollectionKebab } from "./SubcollectionKebab";

interface Props {
  subcollection: Subcollection;
  isOwner: boolean;
  onSelect: () => void;
}

export const SubcollectionRow = ({ subcollection, isOwner, onSelect }: Props) => (
  <div className="flex items-center justify-between px-3 py-2 hover:bg-muted">
    <button className="flex-1 text-left text-sm" onClick={onSelect}>
      {subcollection.name} ({subcollection.member_count})
    </button>
    {isOwner && <SubcollectionKebab subcollection={subcollection} />}
  </div>
);
